import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import type { ModelsState } from "./types";
import { getModelsAction } from "./actions";

export function getModelsReducerBuilder(
  builder: ActionReducerMapBuilder<ModelsState>,
) {
  builder.addCase(getModelsAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.models = action.payload.data;
    state.isInitialized = true;
  });
}
